import {
   addOrRemoveFavoriteItem,
   getFavouritesData,
   initCategories,
   photosetToggleLike,
   photosetToggleWatched,
   videoToggleLike,
   videoToggleWatched,
}  from 'sites/api/MixApi'
import {
   fetchDetailsStart,
   fetchDetailsFailed,
   fetchRequestByFilter,
   fetchRequestByFilterFailed,
   fetchCategoriesCompleted,
   fetchNextDetailsStart,
   fetchNextDetailsFailed,
   fetchDetailsCompleted,
   toggleLikeCompleted,
   toggleWatchedCompleted,
   onChangeFavoriteItemCompleted,
   fetchRequestByFilterCompleted,
   fetchNextDetailsCompleted,
} from "./actions"

import { onChangeFavoriteItemCompleted as onChangeFavoriteItemIntoStore } from 'sites/state/modules/store/actions';
import { onChangeFavoriteItemCompleted as onChangeFavoriteItemIntoVideos } from 'sites/state/modules/videos/actions';
import { onChangeFavoriteItemCompleted as onChangeFavoriteItemIntoLivestreams } from 'sites/state/modules/livestream/actions';
import { onChangeFavoriteItemCompleted as onChangeFavoriteItemIntoPhotosets } from 'sites/state/modules/photosets/actions';
import toast from 'common/utils/toast';
import QueryParams from 'admin/utils/QueryParams';

export const initDataOperation = (params) => {
   return async (dispatch) => {
      dispatch(fetchDetailsStart());
      try {
         const { data }  = await getFavouritesData(params);
         dispatch(fetchDetailsCompleted(data))
      } catch (error) {
         dispatch(fetchDetailsFailed())
      }
   };
};

export const initCategoriesOperation = () => {
   return async (dispatch) => {
      try {
         const { data }  = await initCategories();
         const newData = data.map(el => {
            return {
               value: el.id,
               name: el.name,
            }
         })
         dispatch(fetchCategoriesCompleted(newData))
      } catch (error) {
      }
   };
};

export function fetchNextDataOperation(params) {
   return async (dispatch) => {
      dispatch(fetchNextDetailsStart());
      try {
         const { data }  = await getFavouritesData(params);
         dispatch(fetchNextDetailsCompleted(data))
      } catch (error) {
         dispatch(fetchNextDetailsFailed())
      }
   };
}

export function fetchDataByFilterOperation(params = [], isClearFilters) {
   return async dispatch => {
      dispatch(fetchRequestByFilter());
      try {
         const { data }  = await getFavouritesData(params, true);
         dispatch(fetchRequestByFilterCompleted(data, isClearFilters))
      } catch (error) {
         if(error && error?.code === "ERR_CANCELED") {
            return
         }
         dispatch(fetchRequestByFilterFailed(error));
      }
   }
}



export function toggleLikeOperation(id, type) {
   return async dispatch => {
      try {
         const contentType = type === 'livestream' ? 'recorded_stream' : type
         if(contentType === 'video') {
            await videoToggleLike(id);
         }
         if(contentType === 'recorded_stream') {
            await videoToggleLike(id, '?video_type=livestream');
         }
         if(contentType === 'photoset'){
            await photosetToggleLike(id);
         }
         dispatch(toggleLikeCompleted(id, contentType))
      } catch (error) {
      }
   }
}

export function toggleWatchedOperation(id, type, data) {
   return async dispatch => {
      try {
         const contentType = type === 'livestream' ? 'recorded_stream' : type
         if(contentType === 'videos') {
            await videoToggleWatched(id, '', data);
         }
         if(contentType === 'recorded_stream') {
            await videoToggleWatched(id, '?video_type=livestream', data);
         }
         if(contentType === 'photosets'){
            await photosetToggleWatched(id, data);
         }
         dispatch(toggleWatchedCompleted(id, contentType))
      } catch (error) {
      }
   }
}


export function onChangeFavoriteItemOperation(id, type, isFavoritesPage = false, isDetailsPage = false, successCallBack) {
   return async dispatch => {
      try {
         const sendData = {
            resource_type: type,
            resource_id: id,
         }
         const { data: successMesage } = await addOrRemoveFavoriteItem(sendData)

         if(isFavoritesPage) {
            let isFiltered = !!Object.keys(QueryParams.getFilters())?.length
            dispatch(onChangeFavoriteItemCompleted(id, type, isFiltered))

         } else {
            console.log({ id, type, isFavoritesPage, isDetailsPage });
            if(type === 'video') {
               dispatch(onChangeFavoriteItemIntoVideos(id, isDetailsPage))
            }
            if(type === 'recorded_stream') {
               dispatch(onChangeFavoriteItemIntoLivestreams(id, isDetailsPage))
               if(isDetailsPage) {
                  dispatch(onChangeFavoriteItemIntoVideos(id, isDetailsPage))
               }
            }
            if(type === 'photoset'){
               dispatch(onChangeFavoriteItemIntoPhotosets(id, isDetailsPage))
            }
            if(type === 'store'){
               dispatch(onChangeFavoriteItemIntoStore(id, isDetailsPage))
            }
         }
         toast.success(successMesage)
         if(successCallBack) successCallBack()
      } catch (error) {
         toast.error('Something went wrong')
      }
   }
}
